import React from 'react';
import { useSelector } from 'react-redux';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import {
    ProcedureDetailsTitle,
    ProcedureDetailsSubTitle,
    DetailsMainContainerBlock,
    MainContainerItems,
} from './ProcedureDetails.styled';

import { getDisplayDate } from 'src/utils/dateUtils';
import UnidItem from 'src/common/components/unidItem/UnidItem.jsx';
import { useTranslation } from 'react-i18next';
import { ENABLED, VISIBLE } from 'src/constants/appConstants';
import { COUNTRY_CODE_JAPN } from 'src/constants/productConstants';
import {isMobileDevice} from 'src/utils/util'
const ProcedureDetails = ({ toggleCard, isProcedureDetails, isConsignmentBilling }) => {
    const procedureDetails = useSelector(
        (state) => state.orderSummaryReducer.orderBasicDetails?.procedureDetail
    );
    const currentOrderType = useSelector(
        (state) => state.orderSummaryReducer.orderBasicDetails?.currentOrderType
    );
    const isFromOrderHistory = useSelector(
        (state) =>
            state.orderSummaryReducer.orderBasicDetails?.isFromOrderHistory
    );
    const {
        patientInformationVisibility,
        patientIdVisibility,
        reportUsagePatientDetails,
    } = useSelector((state) => state.loginReducer);

    const { uivArray, livArray } = useSelector(
        (state) => state.reportUsageRootReducer
    );
    const countryCode = localStorage.getItem('countryISOCode');
    const totalLevelsNumber = useSelector(
        (state) => state.reportUsageRootReducer.totalLevelsNumber
    );
   const isCondensedView = useSelector(
          (state) => state.loginReducer.isCondensedView
      );
  

    const { t } = useTranslation();

    const {
        unidCaseId,
        roboticsSystemUsed,
        procedure,
        physicianFinderEligibility,
        retractorsUsed,
        levelsUsed,
        patientSex,
        patientName,
        patientDOB,
        navigationUsed,
        HRefId,
        defermityCorrection,
        biologicsUsed,
        powereaseUsed,
        mazorXRobotUsed,
        unidPlanStatus,
        advancedEnergyUsed,
        isMtoStatus,
        secondaryVendorCaseId,
        mazorCaseCoverageUsed,
        pediatricSurgery,
        stealthAxisCaseCoverageUsed,
        stealthAxisUsed,
        stealthAxisAutoPilot,
        stealthAxisLiveAlign,

    } = procedureDetails || {};

    return (
        <>
            <CollapsableCard
                id="orders-procedureDetails-procedureDetails-details"
                title={t('orders.orderDetails.procedureData.procedureDetails')}
                onClick={() =>
                    toggleCard('isProcedureDetails', !isProcedureDetails)
                }
                isExpanded={isProcedureDetails}
                padding={'0.8rem'}
                cursor={'pointer'}
                margin = {isFromOrderHistory ? '10px 0px 16px 0px' : '10px 0px 2px 0px'}
                mobileMargin = {isCondensedView && !isConsignmentBilling && (isFromOrderHistory ? '10px 16px 16px 16px' : '10px 16px 2px 16px')}
            >
                {isProcedureDetails && procedureDetails ? (
                    isFromOrderHistory ? (
                        <DetailsMainContainerBlock>
                            {patientName &&
                            patientInformationVisibility === VISIBLE &&
                            reportUsagePatientDetails?.includes('name') ? (
                                <MainContainerItems
                                    setMarginBottom={true}
                                    fullWidth
                                >
                                    <ProcedureDetailsTitle showAstrisk={false}>
                                        {t(
                                            'reportUsage.patientDetails.patientName.title'
                                        )}
                                    </ProcedureDetailsTitle>
                                    <ProcedureDetailsSubTitle className="order-procedure-physician-dt-mask">
                                        {patientName}
                                    </ProcedureDetailsSubTitle>
                                </MainContainerItems>
                            ) : null}
                            {procedure ? (
                                <MainContainerItems
                                    setMarginBottom={true}
                                    fullWidth
                                >
                                    <ProcedureDetailsTitle showAstrisk={false}>
                                        {t('common.procedureLabel')}
                                    </ProcedureDetailsTitle>
                                    <ProcedureDetailsSubTitle>
                                        {procedure}
                                    </ProcedureDetailsSubTitle>
                                </MainContainerItems>
                            ) : null}
                        </DetailsMainContainerBlock>
                    ) : (
                    <DetailsMainContainerBlock>
                        {patientName &&
                        patientInformationVisibility === VISIBLE &&
                        reportUsagePatientDetails?.includes('name') ? (
                            <MainContainerItems setMarginBottom={true}>
                                <ProcedureDetailsTitle showAstrisk={false}>
                                    {t(
                                        'reportUsage.patientDetails.patientName.title'
                                    )}
                                </ProcedureDetailsTitle>
                                <ProcedureDetailsSubTitle>
                                    {patientName}
                                </ProcedureDetailsSubTitle>
                            </MainContainerItems>
                        ) : null}
                        {defermityCorrection &&
                        defermityCorrection !== 'none' ? (
                            <MainContainerItems setMarginBottom={true}>
                                <ProcedureDetailsTitle showAstrisk={false}>
                                    {t(
                                        'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.deformityCorrection'
                                    )}
                                </ProcedureDetailsTitle>
                                <ProcedureDetailsSubTitle>
                                    {defermityCorrection}
                                </ProcedureDetailsSubTitle>
                            </MainContainerItems>
                        ) : null}
                        {procedure ? (
                            <MainContainerItems setMarginBottom={true}>
                                <ProcedureDetailsTitle showAstrisk={false}>
                                    {t('common.procedureLabel')}
                                </ProcedureDetailsTitle>
                                <ProcedureDetailsSubTitle>
                                    {procedure}
                                </ProcedureDetailsSubTitle>
                            </MainContainerItems>
                        ) : null}
                        {pediatricSurgery !== '' &&
                        procedure &&
                        pediatricSurgery !== undefined ? (
                            <MainContainerItems setMarginBottom={true}>
                                <ProcedureDetailsTitle showAstrisk={false}>
                                    {currentOrderType === 'ZLB'
                                        ? t('common.pediatricProcedureUsage')
                                        : t('common.pediatricProcedure')}
                                </ProcedureDetailsTitle>
                                <ProcedureDetailsSubTitle>
                                    {pediatricSurgery === true ? 'Yes' : 'No'}
                                </ProcedureDetailsSubTitle>
                            </MainContainerItems>
                        ) : null}
                        {physicianFinderEligibility ? (
                            <MainContainerItems setMarginBottom={true}>
                                <ProcedureDetailsTitle showAstrisk={false}>
                                    {t(
                                        'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.physicianFinder.title'
                                    )}
                                </ProcedureDetailsTitle>
                                <ProcedureDetailsSubTitle>
                                    {physicianFinderEligibility}
                                </ProcedureDetailsSubTitle>
                            </MainContainerItems>
                        ) : null}
                        {roboticsSystemUsed ? (
                            <MainContainerItems setMarginBottom={true}>
                                <ProcedureDetailsTitle showAstrisk={false}>
                                    {t('orders.orderStatuses.robotics')}
                                </ProcedureDetailsTitle>
                                <ProcedureDetailsSubTitle>
                                    {roboticsSystemUsed}
                                </ProcedureDetailsSubTitle>
                            </MainContainerItems>
                        ) : null}
                        {powereaseUsed ? (
                            <MainContainerItems setMarginBottom={true}>
                                <ProcedureDetailsTitle showAstrisk={false}>
                                    {t('orders.orderStatuses.powerused')}
                                </ProcedureDetailsTitle>
                                <ProcedureDetailsSubTitle>
                                    {powereaseUsed ? powereaseUsed : null}
                                </ProcedureDetailsSubTitle>
                            </MainContainerItems>
                        ) : null}
                        {biologicsUsed ? (
                            <MainContainerItems setMarginBottom={true}>
                                <ProcedureDetailsTitle showAstrisk={false}>
                                    {t(
                                        'orders.orderDetails.procedureData.biologicsUsed'
                                    )}
                                </ProcedureDetailsTitle>
                                <ProcedureDetailsSubTitle>
                                    {biologicsUsed ? biologicsUsed : null}
                                </ProcedureDetailsSubTitle>
                            </MainContainerItems>
                        ) : null}
                        {navigationUsed ? (
                            <MainContainerItems setMarginBottom={true}>
                                <ProcedureDetailsTitle showAstrisk={false}>
                                    {t('orders.orderStatuses.stealth')}
                                </ProcedureDetailsTitle>
                                <ProcedureDetailsSubTitle>
                                    {navigationUsed ? navigationUsed : null}
                                </ProcedureDetailsSubTitle>
                            </MainContainerItems>
                        ) : null}
                          {stealthAxisUsed !== '' && stealthAxisUsed!==undefined ? (
                            <MainContainerItems setMarginBottom={true}>
                                <ProcedureDetailsTitle showAstrisk={false}>
                                    {t('orders.orderStatuses.stealthAxis')}
                                </ProcedureDetailsTitle>

                                <ProcedureDetailsSubTitle>
                                    {stealthAxisUsed}
                                </ProcedureDetailsSubTitle>
                            </MainContainerItems>
                        ) : null}
                        {stealthAxisCaseCoverageUsed ? (
                            <MainContainerItems setMarginBottom={true}>
                                <ProcedureDetailsTitle showAstrisk={false}>
                                    {t(
                                        'orders.orderStatuses.stealthAxisCaseCoverage'
                                    )}
                                </ProcedureDetailsTitle>
                                <ProcedureDetailsSubTitle>
                                    {stealthAxisCaseCoverageUsed}
                                </ProcedureDetailsSubTitle>
                            </MainContainerItems>
                        ) : null}
                         {stealthAxisAutoPilot !== null && stealthAxisAutoPilot ==='true' ? (
                            <MainContainerItems setMarginBottom={true}>
                                <ProcedureDetailsTitle showAstrisk={false}>
                                    {t(
                                       'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.StealthAXIS.stealthAxisAutoPilot'
                                    )}
                                </ProcedureDetailsTitle>
                                <ProcedureDetailsSubTitle>
                                    { stealthAxisAutoPilot === 'true' && t('reportUsage.record.reportPayment.ReportPayment.yes')}
                                </ProcedureDetailsSubTitle>
                            </MainContainerItems>
                        ) : null}
                         {stealthAxisLiveAlign !== null && stealthAxisLiveAlign ==='true'  ? (
                            <MainContainerItems setMarginBottom={true}>
                                <ProcedureDetailsTitle showAstrisk={false}>
                                    {t(
                                       'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.StealthAXIS.stealthAxisLiveAlign'
                                    )}
                                </ProcedureDetailsTitle>
                                <ProcedureDetailsSubTitle>
                                    {stealthAxisLiveAlign === 'true' && t('reportUsage.record.reportPayment.ReportPayment.yes')}
                                </ProcedureDetailsSubTitle>
                            </MainContainerItems>
                        ) : null}
                        {mazorXRobotUsed ? (
                            <MainContainerItems setMarginBottom={true}>
                                <ProcedureDetailsTitle showAstrisk={false}>
                                    {t('orders.orderStatuses.mazorx')}
                                </ProcedureDetailsTitle>
                                <ProcedureDetailsSubTitle>
                                    {mazorXRobotUsed ? mazorXRobotUsed : null}
                                </ProcedureDetailsSubTitle>
                            </MainContainerItems>
                        ) : null}
                        {mazorCaseCoverageUsed ? (
                            <MainContainerItems setMarginBottom={true}>
                                <ProcedureDetailsTitle showAstrisk={false}>
                                    Mazor Case Coverage
                                </ProcedureDetailsTitle>
                                <ProcedureDetailsSubTitle>
                                    {mazorCaseCoverageUsed}
                                </ProcedureDetailsSubTitle>
                            </MainContainerItems>
                        ) : null}
                        {advancedEnergyUsed ? (
                            <MainContainerItems setMarginBottom={true}>
                                <ProcedureDetailsTitle showAstrisk={false}>
                                    {t(
                                        'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.advancedEnergy'
                                    )}
                                </ProcedureDetailsTitle>
                                <ProcedureDetailsSubTitle>
                                    {advancedEnergyUsed
                                        ? advancedEnergyUsed
                                        : null}
                                </ProcedureDetailsSubTitle>
                            </MainContainerItems>
                        ) : null}
                        {unidCaseId ? (
                            <MainContainerItems setMarginBottom={true}>
                                <ProcedureDetailsTitle showAstrisk={false}>
                                    {t('orders.searchOrdersPanel.unidcase')}
                                </ProcedureDetailsTitle>

                                <UnidItem
                                    planStatus={unidPlanStatus}
                                    uniDId={unidCaseId}
                                    isShowStatus={true}
                                    showPlan={isMtoStatus}
                                    marginLeft={'0px'}
                                    fromOrderPage
                                />
                            </MainContainerItems>
                        ) : null}
                        {secondaryVendorCaseId ? (
                            <MainContainerItems setMarginBottom={true}>
                                <ProcedureDetailsTitle showAstrisk={false}>
                                    {t('orders.searchOrdersPanel.vendorcase')}
                                </ProcedureDetailsTitle>
                                <ProcedureDetailsSubTitle>
                                    {secondaryVendorCaseId}
                                    {/* DXP : 9070 */}
                                </ProcedureDetailsSubTitle>
                            </MainContainerItems>
                        ) : null}
                        {HRefId &&
                        patientIdVisibility === VISIBLE &&
                        reportUsagePatientDetails?.includes('href') ? (
                            <MainContainerItems setMarginBottom={true}>
                                <ProcedureDetailsTitle showAstrisk={false}>
                                    {t(
                                        'orders.orderDetails.billingSummary.hosppatientref'
                                    )}
                                </ProcedureDetailsTitle>
                                <ProcedureDetailsSubTitle className="order-procedure-physician-dt-mask">
                                    {HRefId}
                                </ProcedureDetailsSubTitle>
                            </MainContainerItems>
                        ) : null}
                        {patientDOB &&
                        patientInformationVisibility === VISIBLE &&
                        reportUsagePatientDetails?.includes('dob') ? (
                            <MainContainerItems setMarginBottom={true}>
                                <ProcedureDetailsTitle showAstrisk={false}>
                                    {t(
                                        'reportUsage.common.patientInformation.patientDob'
                                    )}
                                </ProcedureDetailsTitle>
                                <ProcedureDetailsSubTitle className="order-procedure-physician-dt-mask">
                                    {getDisplayDate(patientDOB)}
                                </ProcedureDetailsSubTitle>
                            </MainContainerItems>
                        ) : null}
                        {patientSex &&
                        patientInformationVisibility === VISIBLE &&
                        reportUsagePatientDetails?.includes('sex') ? (
                            <MainContainerItems setMarginBottom={true}>
                                <ProcedureDetailsTitle showAstrisk={false}>
                                    {t('reportUsage.patientDetails.patientSex')}
                                </ProcedureDetailsTitle>
                                <ProcedureDetailsSubTitle className="order-procedure-physician-dt-mask">
                                    {patientSex}
                                </ProcedureDetailsSubTitle>
                            </MainContainerItems>
                        ) : null}
                        {levelsUsed ? (
                            <MainContainerItems setMarginBottom={true}>
                                <ProcedureDetailsTitle showAstrisk={false}>
                                    {t('orders.index.level')}
                                </ProcedureDetailsTitle>
                                <ProcedureDetailsSubTitle>
                                    {levelsUsed}
                                </ProcedureDetailsSubTitle>
                            </MainContainerItems>
                        ) : null}
                        {retractorsUsed ? (
                            <MainContainerItems setMarginBottom={true}>
                                <ProcedureDetailsTitle showAstrisk={false}>
                                    {t('orders.index.retractor')}
                                </ProcedureDetailsTitle>
                                <ProcedureDetailsSubTitle>
                                    {retractorsUsed}
                                </ProcedureDetailsSubTitle>
                            </MainContainerItems>
                        ) : null}
                    </DetailsMainContainerBlock>
                    )
                ) : null}
            </CollapsableCard>
        </>
    );
};

export default ProcedureDetails;
